<template>
  <form v-if="isLoaded" @submit.prevent="submitForm" novalidate qualification-id="" submit-form user-id="">
    <div class="row">
      <div class="col-lg-9 col-md-12 col-sm-12">
        <BaseInput v-model="formData.type"
                   label="Art"/>
      </div>
      <div class="col-lg-3 col-md-12 col-sm-12">
        <span>Nachweis vorhanden</span>
        <div class="row">
          <BaseRadio
              v-model="formData.proofAvailable"
              label="Ja"
              name="proofAvailable"
              id="1"
              :labelPosition="'right'"
              classFormGroup="col-auto"/>

          <BaseRadio
              v-model="formData.proofAvailable"
              label="Nein"
              name="proofAvailable"
              id="0"
              :labelPosition="'right'"
              classFormGroup="col-auto"/>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center w-100 mt-3">
      <SaveButton
          :label="$t('general.button.save')"
          :loading="isSubmitting"/>
    </div>
  </form>
</template>

<script setup>
import userService from '@/api/User';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { defineEmits, defineProps, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const { t }        = useI18n();
const isLoaded     = ref(false);
const isSubmitting = ref(false);
const emit         = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  userId: {
    type: [ String, Number ],
    required: true,
  },
  qualificationId: {
    type: [ String, Number ],
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const formData = ref({
  userId: '',
  type: '',
  proofAvailable: '0',
});

async function submitForm() {

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {

    if (props.qualificationId) {
      await userService.putQualification(+props.userId, props.qualificationId, formData.value);
    } else {
      await userService.postQualification(+props.userId, formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getQualificationData(qualificationId) {
  try {
    const { data }       = await userService.getSingleQualification(+qualificationId);
    const proofAvailable = String(data.data.proofAvailable);

    formData.value = {
      ...data.data,
      proofAvailable: proofAvailable,
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (props.qualificationId) {
    await getQualificationData(props.qualificationId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>